/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.20.2-27-g52fb3b68-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const BootstrapThemeColor = {
    Primary: 'Primary',
    Secondary: 'Secondary',
    Success: 'Success',
    Danger: 'Danger',
    Warning: 'Warning',
    Info: 'Info',
    Light: 'Light',
    Dark: 'Dark'
};
export function instanceOfBootstrapThemeColor(value) {
    for (const key in BootstrapThemeColor) {
        if (Object.prototype.hasOwnProperty.call(BootstrapThemeColor, key)) {
            if (BootstrapThemeColor[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function BootstrapThemeColorFromJSON(json) {
    return BootstrapThemeColorFromJSONTyped(json, false);
}
export function BootstrapThemeColorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function BootstrapThemeColorToJSON(value) {
    return value;
}
